var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"device-list"},_vm._l((_vm.devices),function(device){return _c('PrDevice',{key:device.id,attrs:{"device":device,"is-selectable":""},on:{"select":_vm.select}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }